
import { defineComponent, computed, ref, watch } from "vue";

type KeyKind = "digit" | "backspace" | "cancel" | "empty";

interface KeyDef {
  id: string;
  label: string;
  value?: string;
  kind?: KeyKind;
  disabled?: boolean;
}

export default defineComponent({
  name: "UiNumberpad",

  props: {
    value: {
      type: String,
      default: ""
    }
  },

  emits: ["change", "cancel"],

  setup(props, { emit }) {

    const currentValue = ref<string>(props.value || "");

    // 🔁 Synchronisation von außen → innen
    watch(
      () => props.value,
      (newVal) => {
        if (newVal !== currentValue.value) {
          currentValue.value = newVal || "";
        }
      }
    );

    const baseKeys = [
      { id: "1", label: "1", value: "1", kind: "digit" },
      { id: "2", label: "2", value: "2", kind: "digit" },
      { id: "3", label: "3", value: "3", kind: "digit" },

      { id: "4", label: "4", value: "4", kind: "digit" },
      { id: "5", label: "5", value: "5", kind: "digit" },
      { id: "6", label: "6", value: "6", kind: "digit" },

      { id: "7", label: "7", value: "7", kind: "digit" },
      { id: "8", label: "8", value: "8", kind: "digit" },
      { id: "9", label: "9", value: "9", kind: "digit" },

      { id: "cancel", label: "✖", kind: "cancel" },
      { id: "0", label: "0", value: "0", kind: "digit" },
      { id: "backspace", label: "⌫", kind: "backspace" }
    ] as const;

    const keys = computed<KeyDef[]>(() =>
      (baseKeys as readonly KeyDef[]).map(k => ({ ...k }))
    );

    function updateValue(newVal: string) {
      currentValue.value = newVal;
      emit("change", newVal);
    }

    function onKey(k: KeyDef) {
      if (k.disabled) return;

      if (k.kind === "digit" && k.value) {
        updateValue(currentValue.value + k.value);
        return;
      }

      if (k.kind === "backspace") {
        updateValue(currentValue.value.slice(0, -1));
        return;
      }

      if (k.kind === "cancel") {
        updateValue("");
        emit("cancel");
        return;
      }
    }

    return {
      keys,
      onKey,
      currentValue
    };
  }
});
